import Laroute from '../laroute';
const axios = require('axios');

// Singleton class
class User {
    constructor() {
        if (!User.instance) {
            User.instance = this;
        }

        return User.instance;
    }

    hasUser() {
        return !_.isUndefined(this.getUser());
    }

    getUser() {
        return this.user;
    }

    setUser(user) {
        this.user = this.mapUserData(user);
    }

    /**
     * @return {Promise}
     */
    getAuthUser() {
        return axios
            .get(Laroute.route('data_api.auth_user'))
            .then(res => {
                this.setUser(res.data);
                Object.freeze(User.instance);

                return res;
            })
            .catch(err => {
                throw err;
            });
    }

    mapUserData(user) {
        return {
            id: user.id,
            name: user.name,
            email: user.email,
            inventory_id: user.inventory_id,
            roles: this.mapUserRoles(user),
            permissions: this.mapUserPermissions(user),
            outlets: user.outlet_ids,
        };
    }

    mapUserPermissions(user) {
        let roles = user.roles;
        let permissions = [];

        roles.forEach(role => {
            role.permissions.forEach(perm => {
                if (permissions.indexOf(perm.name) < 0) {
                    permissions.push(perm.name);
                }
            });
        });

        return permissions;
    }

    mapUserRoles(user) {
        return user.roles.map(role => role.name);
    }
}

const instance = new User();

export default instance;



// WEBPACK FOOTER //
// ./resources/assets/js/libs/user.js